export default {
  navigationBarTitleText: '电子图纸解决方案',
};
